// About page — quality, R&D, logistics, CSR, certifications, wholesale form.
// Config-driven (reads `cfg`, falls back to the original design content).

// ---- QUALITY ASSURANCE ----
function Quality({
  cfg
}) {
  const c = cfg || {};
  const m = useMob();
  const bg = P(c.bg, 'var(--cravy-green)'),
    text = P(c.text, '#fff'),
    accent = P(c.accent, 'var(--cravy-yellow)');
  const qa = [[P(c.card1_title, 'Next-level QA lab'), P(c.card1_body, 'With imported testing tech, we’re all about keeping our fries top-tier.')], [P(c.card2_title, 'RO water system'), P(c.card2_body, 'RO water runs every stage from washing to blanching — nothing but hygienic quality fries.')], [P(c.card3_title, 'Hygiene game strong'), P(c.card3_body, 'Our plant follows the strictest GMP hygiene standards, so you get the safest fries every time.')], [P(c.card4_title, 'Consistency is key'), P(c.card4_body, 'We test texture, taste, and crunch 24/7, so every batch is perfect for your menu.')]];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Quality assurance",
    style: {
      background: bg,
      color: text,
      padding: `clamp(60px,11vh,140px) ${PAD}`
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '1fr 1fr',
      gap: 'clamp(24px,4vw,60px)',
      alignItems: 'end'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    delay: 80,
    style: {
      marginTop: 20
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Quality isn’t a\npriority. It’s\nthe vibe.'))
  })), /*#__PURE__*/React.createElement(Reveal, {
    delay: 120,
    kind: "tiltr",
    style: {
      borderRadius: 24,
      overflow: 'hidden',
      aspectRatio: '16/9'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: P(c.img, ''),
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : 'repeat(2,1fr)',
      gap: 'clamp(14px,2vw,28px)',
      marginTop: 'clamp(34px,5vh,64px)'
    }
  }, qa.map(([h, bdy], i) => /*#__PURE__*/React.createElement(Reveal, {
    key: i,
    delay: i * 70,
    className: "qacard",
    style: {
      background: i % 3 === 0 ? accent : '#fff',
      color: '#000',
      borderRadius: 22,
      padding: 'clamp(22px,2.6vw,38px)',
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 12.5,
      letterSpacing: '0.16em',
      color: 'var(--cravy-green)'
    }
  }, "0", i + 1), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 'clamp(22px,2vw,30px)'
    },
    dangerouslySetInnerHTML: H(h)
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 15,
      lineHeight: 1.45,
      color: '#555'
    },
    dangerouslySetInnerHTML: H(bdy)
  })))));
}
window.CravyAbout.quality = Quality;

// ---- RESEARCH & DEVELOPMENT ----
function Research({
  cfg
}) {
  const c = cfg || {};
  const m = useMob();
  const bg = P(c.bg, '#fff'),
    accent = P(c.accent, 'var(--cravy-red)');
  const rnd = [[P(c.card1_title, 'Potato quality check'), P(c.card1_body, 'We test our fries for texture, taste, and crunch 24/7, so every batch is perfect for your menu.')], [P(c.card2_title, 'Oil quality check'), P(c.card2_body, 'We test Free Fatty Acids, Total Polar Material, and Peroxide Value to make sure the best oil is used for frying.')], [P(c.card3_title, 'Fry perfection test'), P(c.card3_body, 'A frying test plus an oil take-up test (Soxhlet apparatus) guarantees every fry is perfectly crisp and never greasy.')]];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Research and development",
    style: {
      background: bg,
      color: '#000',
      padding: `clamp(60px,11vh,140px) ${PAD}`,
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '0.85fr 1.15fr',
      gap: 'clamp(30px,5vw,80px)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    delay: 80,
    dangerouslySetInnerHTML: H(P(c.heading, 'Always on\nthe grind'))
  }), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    delay: 140,
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 'clamp(16px,1.25vw,19px)',
      lineHeight: 1.45,
      color: '#444',
      maxWidth: 460,
      textWrap: 'pretty'
    },
    dangerouslySetInnerHTML: H(P(c.body, 'Our R&amp;D squad is non-stop, cooking up fresh ideas to bring you next-level fries — new flavors, wild textures, and eco-friendly packaging.'))
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 'clamp(14px,1.6vw,20px)'
    }
  }, rnd.map(([h, b], i) => /*#__PURE__*/React.createElement(Reveal, {
    key: i,
    delay: i * 80,
    className: "qacard",
    style: {
      background: 'var(--cravy-white)',
      borderRadius: 22,
      padding: 'clamp(20px,2.2vw,30px)',
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '0.8fr 1.2fr',
      gap: m ? 10 : 26,
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 'clamp(20px,1.7vw,26px)',
      color: 'var(--cravy-maroon)'
    },
    dangerouslySetInnerHTML: H(h)
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 14.5,
      lineHeight: 1.45,
      color: '#555'
    },
    dangerouslySetInnerHTML: H(b)
  })))));
}
window.CravyAbout.research = Research;

// ---- LOGISTICS & DISTRIBUTION ----
function Logistics({
  cfg
}) {
  const c = cfg || {};
  const m = useMob();
  const bg = P(c.bg, 'var(--cravy-red)'),
    text = P(c.text, '#fff'),
    accent = P(c.accent, 'var(--cravy-yellow)');
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Logistics and distribution",
    style: {
      background: bg,
      color: text,
      padding: `clamp(60px,11vh,140px) ${PAD}`,
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '1.1fr 0.9fr',
      gap: 'clamp(30px,5vw,80px)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    delay: 80,
    dangerouslySetInnerHTML: H(P(c.heading, 'Frozen all\nthe way to you'))
  }), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    delay: 140,
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 'clamp(16px,1.3vw,20px)',
      lineHeight: 1.45,
      maxWidth: 560,
      textWrap: 'pretty'
    },
    dangerouslySetInnerHTML: H(P(c.body, 'Our delivery cars are always on the go. With chilled units built into every vehicle, your fries stay crispy and frozen from us to you — speed and quality, both covered. Restaurants, small businesses, or fry fanatics: we’ve got you.'))
  })), /*#__PURE__*/React.createElement(Reveal, {
    kind: "tiltr",
    style: {
      borderRadius: 26,
      overflow: 'hidden',
      aspectRatio: '4/3',
      boxShadow: '0 26px 60px rgba(0,0,0,0.22)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: P(c.img, ''),
    alt: "Cravy Fries delivery",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  })));
}
window.CravyAbout.logistics = Logistics;

// ---- CSR ----
function CSR({
  cfg
}) {
  const c = cfg || {};
  const m = useMob();
  const bg = P(c.bg, 'var(--cravy-maroon)'),
    text = P(c.text, '#fff'),
    accent = P(c.accent, 'var(--cravy-yellow)');
  const pillars = [[P(c.pillar1_title, 'Zero waste'), P(c.pillar1_body, 'Cutting food waste at every stage of the line.')], [P(c.pillar2_title, 'Fair labor'), P(c.pillar2_body, 'Safe conditions and fair pay across the plant.')], [P(c.pillar3_title, 'Community'), P(c.pillar3_body, 'Fighting hunger with local feeding partners.')], [P(c.pillar4_title, 'Eco packaging'), P(c.pillar4_body, 'R&amp;D into greener bags and cartons.')]];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Corporate social responsibility",
    style: {
      background: bg,
      color: text,
      padding: `clamp(70px,13vh,170px) ${PAD}`,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    delay: 80,
    style: {
      marginTop: 22,
      marginBottom: 26
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Change with\nevery crunch'))
  }), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    delay: 140,
    style: {
      margin: '0 auto',
      maxWidth: 760,
      fontFamily: 'var(--font-body)',
      fontSize: 'clamp(16px,1.35vw,21px)',
      lineHeight: 1.5,
      color: 'rgba(255,255,255,0.88)',
      textWrap: 'pretty'
    },
    dangerouslySetInnerHTML: H(P(c.body, 'We believe in more than just satisfying your cravings — we’re here to make a difference. We’re committed to reducing food waste, promoting fair labor practices, and empowering communities to thrive. Every fry we make is a step toward a better world.'))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : 'repeat(4,1fr)',
      gap: 'clamp(18px,3vw,40px)',
      marginTop: 'clamp(38px,6vh,72px)',
      textAlign: 'left',
      borderTop: '2px solid rgba(255,255,255,0.25)',
      paddingTop: 'clamp(24px,3vh,40px)'
    }
  }, pillars.map(([h, bdy], i) => /*#__PURE__*/React.createElement(Reveal, {
    key: i,
    delay: i * 70,
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontSize: 'clamp(22px,1.9vw,30px)',
      lineHeight: 1,
      textTransform: 'uppercase',
      color: accent
    },
    dangerouslySetInnerHTML: H(h)
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontSize: 14.5,
      lineHeight: 1.4,
      color: 'rgba(255,255,255,0.72)'
    },
    dangerouslySetInnerHTML: H(bdy)
  })))));
}
window.CravyAbout.csr = CSR;

// ---- CERTIFICATIONS ----
function Certifications({
  cfg
}) {
  const c = cfg || {};
  const m = useMob();
  const bg = P(c.bg, '#000'),
    text = P(c.text, '#fff'),
    accent = P(c.accent, 'var(--cravy-yellow)');
  const certs = [[P(c.cert1_title, 'ISO 9001'), P(c.cert1_body, 'Quality you can count on')], [P(c.cert2_title, 'ISO 22000'), P(c.cert2_body, 'Safe fries, no stress')], [P(c.cert3_title, 'EGAC accredited'), P(c.cert3_body, 'Approved by the best')], [P(c.cert4_title, 'Acerta Middle East'), P(c.cert4_body, 'Safety, quality &amp; efficiency')], [P(c.cert5_title, '100% Halal'), P(c.cert5_body, 'From farm to fork, fully traced')]];
  return /*#__PURE__*/React.createElement("section", {
    "data-screen-label": "Certifications",
    style: {
      background: bg,
      color: text,
      padding: `clamp(60px,11vh,140px) ${PAD}`
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    delay: 80,
    style: {
      marginTop: 20
    },
    dangerouslySetInnerHTML: H(P(c.heading, 'Certified\ncrunch'))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 0,
      marginTop: 'clamp(34px,5vh,60px)',
      borderTop: '2px solid rgba(255,255,255,0.25)'
    }
  }, certs.map(([h, b], i) => /*#__PURE__*/React.createElement(Reveal, {
    key: i,
    delay: i * 60,
    style: {
      padding: 'clamp(22px,2.4vw,34px) 0',
      borderBottom: '2px solid rgba(255,255,255,0.25)',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      paddingRight: 24
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontSize: 'clamp(24px,2.1vw,32px)',
      lineHeight: 1,
      color: accent,
      textTransform: 'uppercase'
    },
    dangerouslySetInnerHTML: H(h)
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontSize: 14.5,
      lineHeight: 1.35,
      color: 'rgba(255,255,255,0.7)'
    },
    dangerouslySetInnerHTML: H(b)
  })))), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    delay: 360,
    style: {
      margin: '26px 0 0',
      fontFamily: 'var(--font-body)',
      fontSize: 13,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: 'rgba(255,255,255,0.45)'
    },
    dangerouslySetInnerHTML: H(P(c.footnote, 'QMS Certification · CAB # 117001'))
  }));
}
window.CravyAbout.certifications = Certifications;

// ---- WHOLESALE FORM (wired to Shopify's contact form) ----
const INTERESTS = ['Straight cut 6mm', 'Straight cut 7mm', 'Straight cut 9mm', 'Straight cut 11mm', 'Crinkle cut', 'Curly fries', 'Wedges', 'Private label'];
function AboutInquiry({
  cfg
}) {
  const c = cfg || {};
  const m = useMob();
  const [sent, setSent] = React.useState(false);
  const bg = P(c.bg, 'var(--cravy-yellow)'),
    accent = P(c.accent, 'var(--cravy-maroon)');
  const submit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    const body = new URLSearchParams(new FormData(form));
    body.append('form_type', 'contact');
    body.append('utf8', '✓');
    fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body
    }).catch(() => {}).finally(() => setSent(true));
  };
  return /*#__PURE__*/React.createElement("section", {
    id: "inquiry",
    "data-screen-label": "Wholesale form",
    style: {
      background: bg,
      color: '#000',
      padding: `clamp(48px,8vh,90px) ${PAD}`,
      minHeight: m ? 'auto' : '100vh',
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '0.8fr 1.2fr',
      gap: 'clamp(30px,5vw,80px)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement(Reveal, {
    as: "h2",
    delay: 80,
    dangerouslySetInnerHTML: H(P(c.heading, 'Let’s fry up\nideas together'))
  }), /*#__PURE__*/React.createElement(Reveal, {
    as: "p",
    delay: 140,
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 'clamp(15px,1.2vw,18px)',
      lineHeight: 1.45,
      color: 'var(--cravy-maroon)',
      maxWidth: 400
    },
    dangerouslySetInnerHTML: H(P(c.body, 'Tell us what your kitchen runs through in a week and we’ll come back with pricing, samples, and a delivery schedule.'))
  }), /*#__PURE__*/React.createElement(Reveal, {
    delay: 200,
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      marginTop: 8,
      fontFamily: 'var(--font-body)',
      fontSize: 15,
      lineHeight: 1.4,
      fontWeight: 600
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--cravy-maroon)',
      fontWeight: 500
    },
    dangerouslySetInnerHTML: H(P(c.address, '14 KM Multan Road, opposite Millennium Cable Industries, Lahore'))
  }))), /*#__PURE__*/React.createElement(Reveal, {
    delay: 120,
    style: {
      background: '#fff',
      borderRadius: 26,
      padding: 'clamp(22px,3vw,44px)',
      boxShadow: '0 26px 60px rgba(0,0,0,0.16)'
    }
  }, sent ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      alignItems: 'flex-start',
      padding: '30px 0'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      color: 'var(--cravy-red)'
    },
    dangerouslySetInnerHTML: H(P(c.success_title, 'Thanks — we’re on it!'))
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0,
      fontFamily: 'var(--font-body)',
      fontSize: 16,
      lineHeight: 1.45,
      color: '#444'
    },
    dangerouslySetInnerHTML: H(P(c.success_body, 'A Cravy rep will reach out within one business day with pricing and a sample plan.'))
  }), /*#__PURE__*/React.createElement("span", {
    onClick: () => setSent(false),
    className: "herobtn herobtn-dark",
    style: {
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 14,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      padding: '14px 26px',
      background: '#000',
      color: '#fff',
      borderRadius: 12,
      cursor: 'pointer'
    }
  }, "Send another")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: submit,
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "fld",
    name: "contact[Name]",
    required: true,
    placeholder: "Your name*",
    autoComplete: "name"
  }), /*#__PURE__*/React.createElement("input", {
    className: "fld",
    name: "contact[Business]",
    required: true,
    placeholder: "Restaurant / business name*",
    autoComplete: "organization"
  }), /*#__PURE__*/React.createElement("input", {
    className: "fld",
    name: "contact[Phone]",
    required: true,
    type: "tel",
    placeholder: "Phone number*",
    autoComplete: "tel"
  }), /*#__PURE__*/React.createElement("input", {
    className: "fld",
    name: "contact[email]",
    required: true,
    type: "email",
    placeholder: "Email address*",
    autoComplete: "email"
  })), /*#__PURE__*/React.createElement("input", {
    className: "fld",
    name: "contact[Address]",
    placeholder: "Delivery address",
    autoComplete: "street-address"
  }), /*#__PURE__*/React.createElement("fieldset", {
    style: {
      border: 0,
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      padding: 0,
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 12.5,
      letterSpacing: '0.14em',
      textTransform: 'uppercase',
      color: 'var(--cravy-maroon)'
    }
  }, "Product interest"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 10
    }
  }, INTERESTS.map(p => /*#__PURE__*/React.createElement("label", {
    key: p,
    className: "cb"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: 'contact[Interest: ' + p + ']',
    value: "Yes"
  }), p)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: m ? '1fr' : '1fr 1fr',
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "fld",
    name: "contact[Quantity per order (kg)]",
    required: true,
    type: "number",
    min: "1",
    placeholder: "Quantity per order (kg)*"
  }), /*#__PURE__*/React.createElement("select", {
    className: "fld",
    name: "contact[Recurring volume per week]",
    required: true,
    defaultValue: "",
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true
  }, "Recurring volume / week*"), /*#__PURE__*/React.createElement("option", null, "Under 100 kg"), /*#__PURE__*/React.createElement("option", null, "100–500 kg"), /*#__PURE__*/React.createElement("option", null, "500–1,000 kg"), /*#__PURE__*/React.createElement("option", null, "1,000–5,000 kg"), /*#__PURE__*/React.createElement("option", null, "5,000 kg +"))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "herobtn herobtn-dark",
    style: {
      border: 0,
      fontFamily: 'var(--font-body)',
      fontWeight: 700,
      fontSize: 15,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      padding: '18px 34px',
      background: '#000',
      color: '#fff',
      borderRadius: 12,
      cursor: 'pointer',
      alignSelf: m ? 'stretch' : 'flex-start'
    }
  }, P(c.submit_label, 'Send inquiry')), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-body)',
      fontSize: 12.5,
      lineHeight: 1.4,
      color: '#777'
    }
  }, "We reply within one business day. No spam, just fries.")))));
}
window.CravyAbout.inquiry = AboutInquiry;
Object.assign(window, {
  Quality,
  Research,
  Logistics,
  CSR,
  Certifications,
  AboutInquiry
});

